import React from 'react';
import { Cpu, Github, Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gate-dark border-t border-gate-border pt-16 pb-8" data-id="element-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-12" data-id="element-42">
          <div className="col-span-2 lg:col-span-2" data-id="element-43">
            <div className="flex items-center gap-2 mb-4" data-id="element-44">
              <div className="w-8 h-8 rounded-lg bg-gate-teal/10 flex items-center justify-center border border-gate-teal/20" data-id="element-45">
                <Cpu className="w-5 h-5 text-gate-teal" data-id="element-46" />
              </div>
              <span className="text-lg font-bold text-white" data-id="element-47">
                Open<span className="text-gate-teal" data-id="element-48">FPGA</span>
              </span>
            </div>
            <p className="text-gate-text-secondary text-sm max-w-xs mb-6" data-id="element-49">
              The unified interface for FPGA inference. Access high-performance,
              low-latency hardware without the complexity.
            </p>
            <div className="flex gap-4" data-id="element-50">
              <a href="#" className="text-gate-text-muted hover:text-white transition-colors" data-id="element-51">
                <Github className="w-5 h-5" data-id="element-52" />
              </a>
              <a href="#" className="text-gate-text-muted hover:text-white transition-colors" data-id="element-53">
                <Twitter className="w-5 h-5" data-id="element-54" />
              </a>
              <a href="#" className="text-gate-text-muted hover:text-white transition-colors" data-id="element-55">
                <Linkedin className="w-5 h-5" data-id="element-56" />
              </a>
            </div>
          </div>

          <div data-id="element-57">
            <h3 className="text-white font-semibold mb-4" data-id="element-58">Product</h3>
            <ul className="space-y-3 text-sm text-gate-text-secondary" data-id="element-59">
              <li data-id="element-60">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-61">
                  Accelerators
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-63">
                  Playground
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-65">
                  Rankings
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-67">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-68">
            <h3 className="text-white font-semibold mb-4" data-id="element-69">Developers</h3>
            <ul className="space-y-3 text-sm text-gate-text-secondary" data-id="element-70">
              <li data-id="element-71">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-72">
                  Documentation
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-74">
                  API Reference
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-76">
                  SDKs
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-78">
                  System Status
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-79">
            <h3 className="text-white font-semibold mb-4" data-id="element-80">Company</h3>
            <ul className="space-y-3 text-sm text-gate-text-secondary" data-id="element-81">
              <li data-id="element-82">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-83">
                  About
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-85">
                  Blog
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-87">
                  Careers
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="hover:text-gate-teal transition-colors" data-id="element-89">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gate-border flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-90">
          <p className="text-sm text-gate-text-muted" data-id="element-91">
            © 2026 OpenFPGA. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gate-text-muted" data-id="element-92">
            <a href="#" className="hover:text-white transition-colors" data-id="element-93">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-94">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-95">
              Security
            </a>
          </div>
        </div>
      </div>
    </footer>;
}